import type { IconData } from '@stacksjs/iconify-core'

export const contentImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 6a3 3 0 1 0 0-6a3 3 0 0 0 0 6M0 16h16v-5l-3-3l-3 3l-5-5l-5 5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentImage
